var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_3737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00049 2.0116H20.0532V21.8651H3.00049V2.0116Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_3737)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57359 3.5116C5.91659 3.5116 4.54059 4.8536 4.50159 6.5086V17.2036C4.46459 18.9166 5.81459 20.3276 7.51059 20.3656H15.5746C17.2436 20.2966 18.5656 18.9096 18.5536 17.2096V8.3396L13.9186 3.5116H7.58559H7.57359ZM7.58559 21.8656H7.47659C4.95459 21.8086 2.94659 19.7106 3.00159 17.1876V6.4906C3.05959 4.0096 5.10859 2.0116 7.57159 2.0116H7.58859H14.2386C14.4426 2.0116 14.6376 2.0946 14.7796 2.2416L19.8446 7.5186C19.9786 7.6576 20.0536 7.8446 20.0536 8.0376V17.2036C20.0716 19.7126 18.1176 21.7626 15.6046 21.8646L7.58559 21.8656Z",
    fill: "#757575"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2986 8.98424H16.5436C14.7136 8.97924 13.2256 7.48724 13.2256 5.65924V2.75024C13.2256 2.33624 13.5616 2.00024 13.9756 2.00024C14.3896 2.00024 14.7256 2.33624 14.7256 2.75024V5.65924C14.7256 6.66324 15.5426 7.48124 16.5456 7.48424H19.2986C19.7126 7.48424 20.0486 7.82024 20.0486 8.23424C20.0486 8.64824 19.7126 8.98424 19.2986 8.98424",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7887 16.1084H8.38867C7.97467 16.1084 7.63867 15.7724 7.63867 15.3584C7.63867 14.9444 7.97467 14.6084 8.38867 14.6084H13.7887C14.2027 14.6084 14.5387 14.9444 14.5387 15.3584C14.5387 15.7724 14.2027 16.1084 13.7887 16.1084",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7442 12.3563H8.38818C7.97418 12.3563 7.63818 12.0203 7.63818 11.6063C7.63818 11.1923 7.97418 10.8563 8.38818 10.8563H11.7442C12.1582 10.8563 12.4942 11.1923 12.4942 11.6063C12.4942 12.0203 12.1582 12.3563 11.7442 12.3563",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.2de0f9cf3e758e15591e42932b93d0d0.svg";
export { ForwardRef as ReactComponent };